<template>
  <div class="shop-cart">
    <div class="my-cart">
      <div class="main-cart">
        <div class="title">我的购物车({{goodsNum}})</div>
        <div class="tree-list">
          <div class="nav-lable">
            <el-checkbox v-model="checkAll">全选</el-checkbox>
            <span class="header1">商品</span>
            <span class="header2">单价(元)</span>
            <span class="header2">数量</span>
            <span class="header2">金额(元)</span>
            <span class="header3">操作</span>
          </div>
          <div class="item-goods nav-lable" v-for="(item, index) in goodsData" :key="index">
            <el-checkbox v-model="item.IsSelected" @change="handleChecked(item)"></el-checkbox>
            <div class="goods">
              <img class="img" :src="item.SkuPicUrl" alt="">
              <div class="txt-box">
                <span class="txt">{{item.SkuName}}</span>
                <span class="buy-num">商品起购数量：{{item.MinBuyNum}}</span>
              </div>
            </div>
            <span class="header2">￥{{item.SkuPrice}}</span>
            <span class="header2">
              <el-input-number style="width:100px;margin:5px 0;" :precision="0" :min="1" size="mini" v-model="item.SkuNumber" @change="handleChange(item)"></el-input-number>
            </span>
            <span class="header2">￥{{item.Subtotal}}</span>
            <span class="header3"><el-button type="text" size="mini" @click="deleteFun(item)">删除</el-button></span>
          </div>
        </div>
      </div>
      <div class="settlement">
        <div class="check-box">
          <el-checkbox v-model="checkAll" @change="checkChangeAll">全选</el-checkbox>
        </div>
        <div class="price">
          <div class="total">
            <p><span>合计：</span><span class="red">￥{{SelectedSkuAmount}}</span></p>
            <p><span>已优惠：</span><span>￥8878.00</span></p>
          </div>
          <div class="btn" @click="settlementFun">去结算</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ShoppingCartList,
  ShoppingCartSet,
  ShoppingCartSelect,
  ShoppingCartRemove
} from '../api/api'
export default {
  data(){
    return{
      checked: false,
      goodsNum: 6,
      SelectedSkuAmount: 0,
      subtotal: 0, // 小计
      goodsData: [],
      checkAll: false, // 判断当前是否全选
    }
  },
  created(){
    this.getGoodsList()
  },
  methods:{
    settlementFun(){
      let isSettle = this.goodsData.some(item =>{
        return item.IsSelected
      })
      if(isSettle){
        this.$router.push({path: '/goodsOrder'})
      } else{
        this.$message.error('请至少选中一件商品！')
      }
    },
    getGoodsList(){
      ShoppingCartList().then(res => {
        if(res.data.success){
          this.goodsData = res.data.response.ShoppingCartList || []
          this.goodsData.forEach(item => {
            item.Subtotal = item.SkuPrice * item.SkuNumber
          })
          this.goodsNum = this.goodsData.length
          this.SelectedSkuAmount = res.data.response.SelectedSkuAmount
          this.goodsData.every(item => {
            return this.checkAll = item.IsSelected
          })
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    deleteFun(val){
      this.$confirm('确认删除该商品吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          let params = {
            ids: val.ShoppingCartId
          }
          ShoppingCartRemove(params).then(res => {
            if(res.data.success){
              this.SelectedSkuAmount = res.data.response.SelectedSkuAmount
              this.$message.success(res.data.msg)
              this.getGoodsList()
            } else{
              this.$message.error(res.data.msg)
            }
          })
        }).catch()
      
    },
    handleChange(val){
      if(!val.IsSelected){
        val.IsSelected = true
        this.getShoppingCartSelect(val)
      }
      val.Subtotal = val.SkuNumber * val.SkuPrice
      let params = {
        skuId: val.SkuId,
        skuNumber: val.SkuNumber
      }
      ShoppingCartSet(params).then(res => {
        if(res.data.success){
          this.SelectedSkuAmount = res.data.response.SelectedSkuAmount
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    handleChecked(val){
      this.goodsData.every(item => {
        return this.checkAll = item.IsSelected
      })
      this.getShoppingCartSelect(val)
    },
    getShoppingCartSelect(val){
      let params = {
        ids: val.ShoppingCartId,
        type: val.IsSelected ? 1 : 0
      }
      ShoppingCartSelect(params).then(res => {
        if(res.data.success){
          this.SelectedSkuAmount = res.data.response.SelectedSkuAmount
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    // handleSelectAll(val){
    //   this.checkAll = !this.checkAll
    //   this.checked = !this.checked
    // },
    // handleSelectionChange(val){
    //   console.log(val)
    // },
    checkChangeAll(val){
      this.checkAll = val
      let list = []
      this.goodsData.forEach(item => {
        item.IsSelected = val
        list.push(item.ShoppingCartId)
      })
      
      let params = {
        ids: list.join(),
        type: val ? 1 : 0
      }
      ShoppingCartSelect(params).then(res => {
        if(res.data.success){
          this.SelectedSkuAmount = res.data.response.SelectedSkuAmount
        } else{
          this.$message.error(res.data.msg)
        }
      })
      // this.goodsData.map(row => {
      //   this.$refs.table.toggleRowSelection(row, this.checkAll)
      // })
    },
  }
}
</script>
<style lang="scss" scoped>
.shop-cart{
  background: #ffffff;
}
.el-table /deep/.DisabledSelection .cell .el-checkbox__inner{
  // margin-left: -30px;
  position:relative;
}
.el-table /deep/.DisabledSelection .cell:before{
  content:"全选";
  position:absolute;
  right:11px;
}
.my-cart{
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
  .title{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    line-height: 25px;
    height: 25px;
    text-align: left;
    margin-bottom: 10px;
  }
  .tree-list{
    font-size: 14px;
    color: #999999;
    .nav-lable{
      border: 1px solid #cccccc;
      padding: 10px 20px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .header1{
        width: 600px;
      }
      .header2{
        width: 160px;
      }
      .header3{
        width: 140px;
      }
    }
    .item-goods{
      .goods{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        width: 620px;
        height: 80px;
        padding-left: 10px;
        .img{
          width: 80px;
          height: 80px;
        }
        .txt-box{
          width: 450px;
          height: 80px;
          padding-left: 10px;
          position: relative;
          .txt{
            text-align: left;
            display: inline-block;
            color: #333333;
          }
          .buy-num{
            position: absolute;
            bottom: 0;
            left: 10px;
            font-size: 12px;
          }
        }
      }
    }
  }
  
  .settlement{
    position: sticky;
    bottom: 0;
    z-index: 100;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f3f3f3;
    height: 60px;
    padding-left: 20px;
    .price{
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .total{
        font-size: 14px;
        color: #666666;
        text-align: right;
        line-height: 28px;
        .red{
          font-size: 20px;
          font-weight: bold;
          color: #f40000;
        }
      }
      .btn{
        width: 164px;
        background: #f40000;
        height: 60px;
        line-height: 60px;
        font-size: 20px;
        font-weight: bold;
        color: #ffffff;
        cursor: pointer;
        margin-left: 32px;
      }
    }
  }
}
</style>